import PropTypes from 'prop-types';

export const GoogleLocationPropType = PropTypes.shape({
  locationId: PropTypes.string,
  title: PropTypes.string,
  storefrontAddress: PropTypes.shape({
    addressLines: PropTypes.arrayOf(PropTypes.string),
    locality: PropTypes.string,
    postalCode: PropTypes.string,
    administrativeArea: PropTypes.string,
    regionCode: PropTypes.string,
  }),
  metadata: PropTypes.shape({
    duplicateLocation: PropTypes.string,
    mapsUri: PropTypes.string,
    hasVoiceOfMerchant: PropTypes.bool,
    canHaveFoodMenus: PropTypes.bool,
    canModifyServiceList: PropTypes.bool,
    placeId: PropTypes.string,
  }),
});

export const ProfileSettingsPropType = PropTypes.shape({});
export const LocationSettingsPropType = PropTypes.shape({});

export const ActionSettingsPropType = PropTypes.shape({
  supported: PropTypes.bool,
  settings: PropTypes.shape({
    enabled: PropTypes.bool,
  }),
});
